export default __webpack_public_path__ + "4643411.png";